import React, { Component } from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import Checkbox from './Checkbox';
import { setFormikMultipleValues } from '../../../utils/index';

const StyledCheckboxGroup = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: ${({ isInline }) => (isInline ? 'row' : 'column')};
  align-items: ${({ isInline }) => (isInline ? 'center' : 'flex-start')};
  margin-bottom: 20px;
`;

class CheckboxGroup extends Component {
  handleCheckboxChange = e => {
    const { checkboxProps = {} } = this.props;
    const { name, setFieldValue, setFieldTouched, values, onChange } = checkboxProps;
    if (name) {
      setFormikMultipleValues(e.target, values, setFieldValue);
      setFieldTouched(name, true);
      if (onChange) {
        onChange(e);
      }
    }
  };
  handleCheckboxBlur = e => {
    const { checkboxProps = {} } = this.props;
    const { name, setFieldTouched, onBlur } = checkboxProps;
    if (name) {
      setFieldTouched(name, true);
      if (onBlur) {
        onBlur(e);
      }
    }
  };
  render() {
    const { className, checkboxProps = {}, label = '', error = '', hint = '', isInline = false } = this.props;
    const classNames = [];
    if (className) {
      classNames.push(className);
    }
    return (
      <StyledCheckboxGroup className={classNames.join(' ')} error={error} isInline={isInline}>
        <Checkbox
          {...checkboxProps}
          error={error}
          hint={hint}
          isInline={isInline}
          label={label}
          onChange={this.handleCheckboxChange}
          onBlur={this.handleCheckboxBlur}
        />
      </StyledCheckboxGroup>
    );
  }
}

export default CheckboxGroup;
